import styled from "styled-components";
import { Link } from "react-router-dom";
import { AiFillHome } from "react-icons/ai";
import { IoPersonSharp } from "react-icons/io5";
import { ImBlog } from "react-icons/im";
import { BiTrip } from "react-icons/bi";

const MobileHeader = () => {
  return (
    <>
      <List>
        <li>
          <Link to="/">
            <span>
              <IoPersonSharp />
            </span>
            حساب کاربری
          </Link>
        </li>
        <li>
          <Link to="/blog">
            <span>
              <ImBlog />
            </span>
            وبلاگ
          </Link>
        </li>
        <li>
          <Link to="/">
            <span>
              <BiTrip />
            </span>
            سفرهای من
          </Link>
        </li>
        <li>
          <Link to="/">
            <span>
              <AiFillHome />
            </span>
            خانه
          </Link>
        </li>
      </List>
    </>
  );
};

export default MobileHeader;

const List = styled.ul`
  list-style: none;
  display: flex;
  justify-content: space-between;
  position: fixed;
  bottom: 0;
  right: 0;
  left: 0;
  padding: 5px 30px;
  background-color: #f3f3f3;
  margin-top: 10px;
  z-index: 10;
  align-items: center;
  text-align: center;
  
  @media( min-width: 900px){
    display: none;
  }

  a {
    text-decoration: none;
    color: rgba(0, 0, 0, 0.8);
    font-size: 18px;
    font-weight: 400;
    display: flex;
    flex-direction: column;

    @media (max-width: 600px) {
      font-size:16px;
    }

    :hover {
      color: #3a3afc;
    }
  }

  span {
    font-size: 21px;
    text-align: center;
  }
`;
